import * as React from "react";
import { Facebook, Twitter, Instagram } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const teamMembers = [{
  id: 1,
  name: "Ricardo Silveira",
  role: "ESTRATEGISTA EXECUTIVO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/partner_ricardo_silveira.png",
  facebook: "#",
  twitter: "#",
  instagram: "#"
}, {
  id: 2,
  name: "Helena Cavalcanti",
  role: "MENTORA DE LIDERANÇA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/specialist_helena_cavalcanti.png",
  facebook: "#",
  twitter: "#",
  instagram: "#"
}, {
  id: 3,
  name: "Arthur Mendes",
  role: "CONSELHEIRO DE CARREIRA",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/partner_arthur_mendes.png",
  facebook: "#",
  twitter: "#",
  instagram: "#"
}];
export default function OurProfessionalTeam() {
  return;
}